var map = {
	"./de.svg": "+01g",
	"./en.svg": "R8LK",
	"./hr.svg": "xdyl",
	"./ru.svg": "+bxa"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "oAeA";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lang ^\.\/.*\.svg$
// module id = oAeA
// module chunks = 1